export default __webpack_public_path__ + "static/media/abbv-white.4bd71e1b.svg";